export default __webpack_public_path__ + "static/media/insulin-morning-icon.a1cd7f1a.svg";